module.exports = __webpack_public_path__ + "static/media/blog-web-1.6636a539.png";